import { render, staticRenderFns } from "./issueCharges.vue?vue&type=template&id=6350570a"
import script from "./issueCharges.ts?vue&type=script&lang=js&external"
export * from "./issueCharges.ts?vue&type=script&lang=js&external"
import style0 from "./issueCharges.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports